import { Component, Inject, OnInit, Attribute } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { SpinnerService } from '../../../services/spinner.service';
import { DownloadService } from '../../../services/download.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { OpenSddrContributionsDisDialogComponent } from '../open-sddr-contributions-dis-dialog/open-sddr-contributions-dis-dialog.component';
import { OpenSddrContributionsDisDeclineDialogComponent } from '../open-sddr-contributions-dis-cancel-dialog/open-sddr-contributions-dis-cancel-dialog.component';
import { FormatCurrencyPipe } from '../../../share/pipe/FormatCurrency.pipe';

import {
  AportacionDIEstadoControllerService,
  AportacionDIEstadoDTO,
  AportacionDIPoseedorControllerService,
  AportacionDisddrcaControllerService,
  AportacionDISDDRCAFilterDTO,
  PageDTOAportacionDISDDRCADTO,
  SolicitudNimaPoseedorDTO,

  PlataformaOrigenControllerService, PlataformaOrigenDTO,
  DiccionarioControllerService,
  DiccionarioElementoDTO
} from 'api-rest';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import moment from 'moment';
import {
  OpenSddrContributionsDisSelectionDialogComponent
} from "../open-sddr-contributions-dis-selection-dialog/open-sddr-contributions-dis-selection-dialog.component";
import { OpenSddrContributionsDisPreviewDialogComponent } from '../open-sddr-contributions-dis-preview-dialog/open-sddr-contributions-dis-preview-dialog.component';
import { SolicitudNimaGestoresDTO } from 'dist/api-rest/api-sddrabierto/model/solicitudNimaGestoresDTO';
import { GestionResiduosFilterDTO } from 'dist/api-rest/api-sddrabierto';
@Component({
  selector: 'app-open-sddr-contributions-dis',
  templateUrl: './open-sddr-contributions-dis.component.html',
  styleUrls: ['./open-sddr-contributions-dis.component.scss'],
})
export class OpenSddrContributionsDisComponent implements OnInit {
  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;
  mostrarFiltros: boolean = true;

  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  flagSearch: boolean = false;
  totalElements: number = 0;
  totalSearch: number = 0;
  nimaGestorArray: any[] = [];
  nimaPoseedorArray: any[] = [];
  gestorArray: any[] = [];
  poseedorArray: any[] = [];
  estadoArray: any[] = [];
  plataformaOrigenArray: any[] = [];
  headArray: any[] = []
  headArrayAcondicionador: any[] = [
    {
      Head: 'ID. Acondicionador',
      renderValue: (item: any) =>
              item.acondicionador ? item.acondicionador.id : item.solicitudRetirada?.poseedor ? item.solicitudRetirada?.poseedor.id : item.solicitudRetirada?.adherido ? item.solicitudRetirada?.adherido.id : '',
    },
    {
      Head: 'Razón social Acondicionador',
      renderValue: (item: any) =>
              item.acondicionador ? item.acondicionador.razonSocial : item.solicitudRetirada?.poseedor ? item.solicitudRetirada?.poseedor.razonSocial : item.solicitudRetirada?.adherido ? item.solicitudRetirada?.adherido.razonSocial : '',
    },
    {
      Head: 'Documento Acondicionador',
      renderValue: (item: any) =>
              item.acondicionador ? item.acondicionador.codigoDocumento : item.solicitudRetirada?.poseedor ? item.solicitudRetirada?.poseedor.codigoDocumento : item.solicitudRetirada?.adherido ? item.solicitudRetirada?.adherido.codigoDocumento : '',
    },
    {
      Head: 'NIMA del Acondicionador',
      renderValue: (item: any) =>
              item.acondicionador ? item.acondicionador.nima : item.solicitudRetirada?.poseedor ? item.solicitudRetirada?.poseedor.nima : item.solicitudRetirada?.adherido ? item.solicitudRetirada?.adherido.nima : '',
    }
  ] 
  headArrayGestor: any[] = [
    {
      Head: 'ID. Gestor',
      FieldName: 'gestorResiduo',
      Attribute: 'id'
    },
    {
      Head: 'Razon social gestor',
      FieldName: 'razonSocialGestor',
      renderValue: (item: any) => item?.gestorResiduo ? item?.gestorResiduo.razonSocial : item?.razonSocialGestor,
    },
    {
      Head: 'Documento gestor',
      FieldName: 'documentoGestor',
      renderValue: (item: any) => item?.gestorResiduo ? item?.gestorResiduo.codigoDocumento : item?.documentoGestor,
    },
    {
      Head: 'NIMA del gestor',
      FieldName: 'nimaGestor',
      renderValue: (item: any) => item?.gestorResiduo ? item?.gestorResiduo.nima : item?.nimaGestor,
    },
  ]
  headArrayAux: any = [
    {
      Head: 'Fecha de aportación',
      FieldName: 'fechaMAportacion',
    },
    {
      Head: 'Fecha de aceptación',
      FieldName: 'fechaMAceptacion',
    },
    {
      Head: 'DI/FS',
      FieldName: 'documentoIdentificacion',
    },
    {
      Head: 'Código LER y descripción de ENVALORA',
      FieldName: 'descripcionMCodLer',
      //renderValue: (item: any) => `${item?.codigoLer?.tipoCodigo} ${item?.codigoLer?.descripcion}`,
    },
    {
      Head: 'Cantidad neta gestionada (Kg)',
      FieldName: 'cantidadGestionada',
      renderValue: (item: any) => this.formatCurrencyPipe.transform(item.cantidadGestionada),
    },
    {
      Head: 'Origen ',
      FieldName: 'origen',
      renderValue: (item: any) => item?.origen === 'SDDRCA' ? 'SDDR Abierto' : item?.origen,
    },
    {
      Head: 'Estado ',
      FieldName: 'estado',
      Attribute: 'descripcionCorta',
    },
    {
      Head: 'Cargado por',
      FieldName: 'esCreadoPoseedor',
      renderValue: (item: any) =>
            item.esCreadoPoseedor ? 'Poseedor' : 'Acondicionador',
    },
    // {
    //   Head: 'Plataforma origen',
    //   FieldName: 'plataformaOrigen',
    //   Attribute: 'descripcion',
    // },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      check: this.canViewResource('SDDR-CA-ENV-GEST'),
      buttons: [
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Detalle ',
          show: {
            params: 'canAccessView',
            accion: 'view',
          },
        },
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Eliminar',
          show: {
            params: 'canAccessDelete',
            accion: 'delete',
          },
        },
        {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'preview',
              name: 'Vista previa',
              show: { params: 'canAccessPreview', accion: 'preview' },
            },
            {
              nameButton: 'send',
              name: 'Enviar aportación ',
              show: {
                params: 'canAccessSend',
                accion: 'send',
              },
            },
            {
              nameButton: 'accept',
              name: 'Aceptar aportación',
              show: { params: 'canAccessAccept', accion: 'accept' },
            },
            {
              nameButton: 'cancel',
              name: 'Cancelar aportación',
              show: { params: 'canAccessCancel', accion: 'cancel' },
            },
          ],
        },
      ],
      width: '15',
      permanent: true,
    },
  ];

  auxArrayPlataformaOrigigen: any = [
        {
      Head: 'Plataforma origen',
      FieldName: 'plataformaOrigen',
      Attribute: 'descripcion',
    },
  ]
  gridArray: any[] = [];

  searchForm: FormGroup;

  updateList: boolean = false;

  listaGestores = this.environment.urlBackCore + 'api/v1/poseedores/gestores-residuos';
  listaMisGestores = this.environment.urlBackCore + 'api/v1/poseedores/gestores-residuos/byUser';

  defaultGestoresParameters = { 'gestorResiduos': true, 'gestoresResiduosEstado.id': [2, 3] };
  defaultAcondicionadoresParameters = { 'esAcondicionador': true }

  poseedorEndpoint: string = this.environment.urlBackPoseedores + `api/v1/poseedores/poseedor`;
  defaultPoseedoresParameters = { 'estado.id': 4 };

  rolesGestor: any[] = [];
  rolesPoseedor: any[] = [];

  isGestor : boolean = false;
  orden: DiccionarioElementoDTO[] = [];
  constructor(
    @Inject('environment') private environment: any,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private downloadService: DownloadService,
    private snackBarSrv: SnackbarService,
    private aportacionDisddrcaCtrSrv: AportacionDisddrcaControllerService,
    private aportacionesDiPoseedorCtrSrv: AportacionDIPoseedorControllerService,
    @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService | any,
    private aportacionDIEstadoCtrSrv: AportacionDIEstadoControllerService,
    private plataformaOrigenControllerService: PlataformaOrigenControllerService,
    private formatCurrencyPipe: FormatCurrencyPipe,
    private diccionarioControllerService: DiccionarioControllerService
  ) {
    const fechaInicialDesde = new Date(new Date().getFullYear(), 0, 1);
    const fechaActual = new Date();

    const roleEntities = (this.authService.user as any).roleEntities;
    this.rolesGestor = roleEntities?.filter(
      (roleEntity: any) => roleEntity.role == 'PO-GESTOR'
    );
    //Se quita acceso al poseedor para crear aportaciones dentro del SDDR Abierto (las crearan en Poseedores finales)
    //this.rolesPoseedor = roleEntities?.filter(
    //  (roleEntity: any) => roleEntity.role == 'PO-POSEEDOR'
    //);

    //if(this.canViewResource('PO-GESTOR')){
    //  this.headArray = this.headArrayGestor;
    //  this.headArray = this.headArray.concat(this.headArrayAcondicionador);
    //  this.headArray = this.headArray.concat(this.headArrayAux);
    //}else{
      this.headArray = this.headArrayAcondicionador;
      this.headArray = this.headArray.concat(this.headArrayGestor);
    if (this.esGestorEnvalora()) {
      this.headArray = this.headArray.concat(this.auxArrayPlataformaOrigigen)
    }
      this.headArray = this.headArray.concat(this.headArrayAux);
    //}

    this.searchForm = this.formBuilder.group({
      gestor: [{ value: null, disabled: false }],
      idGestor: [{ value: null, disabled: false }, [Validators.pattern('^[0-9;]+$')]],
      acondicionador: [{ value: null, disabled: false }],
      idAcondicionador: [{ value: null, disabled: false }, [Validators.pattern('^[0-9;]+$')]],
      //poseedor: [{ value: null, disabled: false }],
      //idposeedor: [{ value: null, disabled: false }, [Validators.pattern('^[0-9]+$'), Validators.maxLength(10)]],
      //codigo_documento_pos: [{ value: null, disabled: false }],
      codigo_documento_gest: [{ value: null, disabled: false }],
      codigo_documento_acond: [{ value: null, disabled: false }],
      //razon_social_pos: [{ value: null, disabled: false }],
      razon_social_gest: [{ value: null, disabled: false }],
      razon_social_acond: [{ value: null, disabled: false }],
      //nima_poseedor: [{ value: null, disabled: false }],
      nima_gestor: [{ value: null, disabled: false }],
      nima_acondicionador: [{ value: null, disabled: false }],
      fecha_desde: [
        { value: fechaInicialDesde, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      fecha_hasta: [
        { value: fechaActual, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      fecha_aport_desde: [
        { value: null, disabled: false },
      ],
      fecha_aport_hasta: [
        { value: null, disabled: false },
      ],
      doc_identificacion: [{ value: null, disabled: false }, [Validators.minLength(6)]],
      estado: [{ value: null, disabled: false }],
      origen: [{ value: null, disabled: false }],
      plataformaOrigen: [{ value: null, disabled: false }],
      orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],

    });

    if (this.rolesGestor?.length > 0) {
      this.isGestor = true;
      this.buscarNimaGestor();
    }
    if (this.rolesPoseedor?.length > 0){
      this.buscarNimaPoseedor();
    }else{
      this.getPoseedoresPorGestor();
    }
  }

  ngOnInit() {
    this.comboEstados();
    this.comboPlataformaOrigen();
    this.comboOrden();
  }

  checked(event: any) {
    if (event.estado.id != 3) {
      this.snackBarSrv.showSnackBar(
        'Solo se permitirá prefacturar DIs en estado Aceptada',
        'error'
      );
      event.checked = null;
    }
  }

  renderPage(event: number) {
    this.pageNumber = event;
    if (this.flagSearch) {
      this.searchData();
    }
  }

  private getBackendFilter() {
    let fechaBusqueda: Array<string> = [];
    let fechaDesde = this.searchForm.get('fecha_desde')?.value;
    let fechaHasta = this.searchForm.get('fecha_hasta')?.value;

    if (fechaDesde) {
      let formatDateDesde = moment(new Date(fechaDesde)).format('YYYY-MM-DD');
      formatDateDesde = `gte(${formatDateDesde})`;
      fechaBusqueda.push(formatDateDesde);
    }
    if (fechaHasta) {
      let formatDateHasta = moment(new Date(fechaHasta)).format('YYYY-MM-DD');
      if (fechaDesde) {
        formatDateHasta = `and(lte(${formatDateHasta}))`;
      } else {
        formatDateHasta = `lte(${formatDateHasta})`;
      }
      fechaBusqueda.push(formatDateHasta);
    }
    //Fecha aportacion
    let fechaAportacion : string[] | undefined;
    if(this.searchForm.get('fecha_aport_desde')?.value || this.searchForm.get('fecha_aport_hasta')?.value){
      fechaAportacion = [];
      if(this.searchForm.get('fecha_aport_desde')?.value){
        let formatDateAportDesde = moment(
          new Date(this.searchForm.get('fecha_aport_desde')?.value)
        ).format('YYYY-MM-DD');

        formatDateAportDesde = `gte(${formatDateAportDesde})`;
        fechaAportacion.push(formatDateAportDesde);
      }
      if(this.searchForm.get('fecha_aport_hasta')?.value){
        let formatDateAportHasta = moment(
          new Date(this.searchForm.get('fecha_aport_hasta')?.value)
        ).format('YYYY-MM-DD');

        formatDateAportHasta = `and(lte(${formatDateAportHasta}))`;
        fechaAportacion.push(formatDateAportHasta);
      }
    }
    let gestorFilter: GestionResiduosFilterDTO = {}
    const selectGestores = this.searchForm.get('gestor')?.value;
    if(selectGestores && selectGestores.length > 0){
      gestorFilter = {
        id: selectGestores?.map((objeto: any) =>
          objeto.id !== undefined ? objeto.id : objeto
        ),
      }
    }else{
      gestorFilter = {
        id: [this.searchForm.get('idGestor')?.value],
        //razonSocial: this.searchForm.get('razon_social_gest')?.value,
        //nima: this.searchForm.get('nima_gestor')?.value ? [this.searchForm.get('nima_gestor')?.value] : undefined,
        //codigoDocumento: this.searchForm.get('codigo_documento_gest')?.value,
      }
    }
   
    const selectAcondicionadores = this.searchForm.get('acondicionador')?.value;
    let acondicionadorFilter: any;
    if(selectAcondicionadores && selectAcondicionadores.length > 0){
      acondicionadorFilter = {
        id: selectAcondicionadores?.map((objeto: any) =>
          objeto.id !== undefined ? objeto.id : objeto
        ),
      }
    }else{
      acondicionadorFilter = {
        id: [this.searchForm.get('idAcondicionador')?.value],
        nima: [this.searchForm.get('nima_acondicionador')?.value],
        codigoDocumento: [this.searchForm.get('codigo_documento_acond')?.value],
      }
    }

    const selectEstado = this.searchForm.get('estado')?.value;
    let selectEstadosId: any[] = [];
    if (selectEstado !== undefined && selectEstado !== null) {
      selectEstadosId = selectEstado.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }

    let backendFilter: AportacionDISDDRCAFilterDTO = {
      //gestorResiduo: {
      //  id: [selectGestores?.map((objeto: any) =>
      //    objeto.id !== undefined ? objeto.id : objeto
      //  ),
      //  this.searchForm.get('idGestor')?.value
      //  ],
      //  nima: this.searchForm.get('nima_gestor')?.value,
      //  codigoDocumento: this.searchForm.get('codigo_documento_gest')?.value
      //},
      gestorResiduo: gestorFilter, 
      //poseedor: poseedorFilter, 
      acondicionador: acondicionadorFilter,
      fechaAceptacion: fechaBusqueda,
      fechaAportacion: fechaAportacion,
      documentoIdentificacion: this.searchForm.get('doc_identificacion')?.value ? this.searchForm.get('doc_identificacion')?.value.trim() : undefined,
      estado: {id: selectEstadosId},
      origen: this.searchForm.get('origen')?.value,
      plataformaOrigen: this.searchForm.get('plataformaOrigen')?.value,
    };
    if(this.searchForm.get('nima_gestor')?.value){
      backendFilter.nimaGestor = this.searchForm.get('nima_gestor')?.value;
    }
    if(this.searchForm.get('razon_social_gest')?.value){
      backendFilter.razonSocialGestor = this.searchForm.get('razon_social_gest')?.value;
    }
    if(this.searchForm.get('codigo_documento_gest')?.value){
      backendFilter.documentoGestor = this.searchForm.get('codigo_documento_gest')?.value;
    }
    if(this.searchForm.get('razon_social_acond')?.value){
      backendFilter.razonSocialAcondicionador = this.searchForm.get('razon_social_acond')?.value;
    }

    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    const orden = this.searchForm.get('orden')?.value;
    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    return { backendFilter, page, size: this.pageSize, orden, tipoOrden };
  }

  exportarExcel() {
    const { backendFilter, page, size } = this.getBackendFilter();
    this.aportacionDisddrcaCtrSrv
      .exportCSV5(backendFilter, 'response')
      .subscribe((res: any) => {
        this.downloadService.exportModal();
        // const filename = this.downloadService.getFileName(
        //   res.headers,
        //   'ExportacionAportacionesDi.csv'
        // );
        // this.downloadService.downloadCSV(res.body!, filename!);
      });
  }

  getGestorDescription(obj: any) {
    return obj?.nima + ' - ' + obj?.razonSocial;
  }

  getPoseedorDescription(obj: any) {
    return obj.nima + ' - ' + obj.razonSocial;
  }

  getGestorObjectQuery(searchterm: string) {
    return {
      razonSocialOrNima: searchterm,
      'estado.id': 4,
    };
  }

  getPoseedorObjectQuery(searchterm: string) {
    return {
      razonSocialOrNima: `${searchterm}`,
      'estado.id': 4,
    };
  }

  getPoseedoresPorGestor() {
    if(this.rolesGestor?.length > 0){
      const gestorIds = this.rolesGestor.flatMap((gestorRol: any) => {
          if(gestorRol.entity == null || gestorRol.entity == undefined){
            return [];
          }else if (Array.isArray(gestorRol.entity)) {
            return gestorRol.entity;
          } else {
            return [gestorRol.entity];
          }
        });
      const filtroNimaPoseedor: any = {
        fechaAceptacion: moment(new Date()).format('YYYY-MM-DD'),
        gestor: {
          id: gestorIds,
        },
      };

      this.spinnerSrv.loadingShow();
      this.aportacionesDiPoseedorCtrSrv
        .getPoseedoresEnPrevision(filtroNimaPoseedor)
        .subscribe({
          next: (response: any) => {
            this.poseedorArray = response;
            this.spinnerSrv.loadingHide();
          },
          error: (err) => {
            console.log(err);
            this.spinnerSrv.loadingHide();
          },
        });
      } 
    }

  clearSearcher() {
    this.searchForm.reset();
    this.flagSearch = false;
    this.gridArray = [];
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.searchForm.controls[controlName].hasError(errorName) &&
      this.searchForm.controls[controlName].touched
    );
  }

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'gestor': {
        return this.searchForm.get('gestor') as FormControl;
      }
      case 'poseedor': {
        return this.searchForm.get('poseedor') as FormControl;
      }
      case 'acondicionador': {
        return this.searchForm.get('acondicionador') as FormControl;
      }
      default: {
        return this.searchForm.get('') as FormControl;
      }
    }
  }

  searchData(initPage:boolean = false) {
    if(initPage){
      this.pageNumber = 0;
    }
    if (this.searchForm.invalid) {
      this.searchForm.markAllAsTouched();
      this.snackBarSrv.showSnackBar(
        'Debe completar los campos obligatorios',
        'error'
      );
      return;
    }
    const { backendFilter, page, size, orden, tipoOrden } = this.getBackendFilter();
    this.spinnerSrv.loadingShow();
    this.aportacionDisddrcaCtrSrv
      ?.findAll6(backendFilter, {
        page: page,
        size: size,
        sort: ['id,desc'],
      },
        orden,
        tipoOrden
      )
      .subscribe({
        next: (data: PageDTOAportacionDISDDRCADTO) => {
          if (data) {
            this.spinnerSrv.loadingHide();
            this.flagSearch = data.datos?.length != 0;
            this.gridArray = this.canAccessAll(data.datos);
            this.recordsTotal = data.paginacion?.totalElements ?? 0;
            this.totalSearch = this.gridArray.length;
          }
        },
        error: (error: any) => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.searchData();
  }

  action(element: any) {
    if (element.nameButton == 'view') {
      this.openModalContributions(element);
    } else if (element.nameButton == 'delete') {
      this.confirmacionEliminar(element);
    } else if (element.nameButton == 'send') {
      this.spinnerSrv.loadingShow();
      this.aportacionDisddrcaCtrSrv
        .enviarAportacion(element.id)
        .subscribe({
          next: () => {
            this.spinnerSrv.loadingHide();
            this.searchData();
            this.snackBarSrv.showSnackBar(
              'Se ha enviado la aportación correctamente',
              'success'
            );
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            console.log(err);
          },
        });
    } else if (element.nameButton == 'accept') {
      this.spinnerSrv.loadingShow();
      this.aportacionDisddrcaCtrSrv
        .aceptarAportacion(element.id)
        .subscribe({
          next: () => {
            this.spinnerSrv.loadingHide();
            this.searchData();
            this.snackBarSrv.showSnackBar(
              'Se ha aceptado la aportación correctamente',
              'success'
            );
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            console.log(err);
          },
        });
    } else if (element.nameButton == 'cancel') {
      this.openModalMotivoCancel(element);
    }else if (element.nameButton == 'preview'){
      this.vistaPreviaAportacion(element.documento);
    }
  }

  confirmacionEliminar(element?: any): void {
    Swal.fire({
      text: `¿Desea eliminar la aportación DI/FS?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminarDis(element);
      }
    });
  }

  eliminarDis(element?: any) {
    if (element?.id) {
      this.spinnerSrv.loadingShow();
      this.aportacionDisddrcaCtrSrv
        .deleteById2(element.id)
        .subscribe({
          next: (value: any) => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              `La aportación DI/FS se ha eliminado correctamente`,
              'success'
            );
            this.gridArray = this.gridArray.filter(
              (objeto) => objeto.id !== element.id
            );
            this.flagSearch = this.gridArray.length != 0;
          },
          error: (err: { message: any }) => {
            this.spinnerSrv.loadingHide();
          },
        });
    }
  }

  comboEstados() {
    this.aportacionDIEstadoCtrSrv.findAll14().subscribe({
      next: (data: Array<AportacionDIEstadoDTO>) => {
        this.estadoArray = data?.filter(item => item.id !== 1 && item.id !== 6) || [];
      },
      error: () => { },
    });
  }
  comboOrden() {
    this.diccionarioControllerService.listarElementos(['ORDEN_SDDR_ABIERTO_APORTACIONES_DI_FS_BUSQUEDA']).subscribe({
      next: (data:any) => {
        this.orden = data['ORDEN_SDDR_ABIERTO_APORTACIONES_DI_FS_BUSQUEDA'] || [];
      },
      error: () => {},
    });
  }
  comboPlataformaOrigen() {
    this.plataformaOrigenControllerService.findAll6().subscribe({
      next: (data: Array<PlataformaOrigenDTO>) => {
        this.plataformaOrigenArray = data!;
      },
      error: () => {},
    });
  }

  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.searchForm.controls[controlName]?.touched ||
        this.searchForm.controls[controlName]?.dirty) &&
      this.searchForm.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }

  showClearButton(formName: string): boolean {
    return this.searchForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.searchForm.get(formName)?.setValue(null);
  }

  openHolderManagerSelection() {
    const dialogRef = this.dialog.open(OpenSddrContributionsDisSelectionDialogComponent, {
      width: '950px',
      maxWidth: '98%',
      maxHeight: '95vh',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.openModalContributions(result);
      }
    });
  }

  buscarNimaGestor() {
    const filtroNimaGestor: SolicitudNimaGestoresDTO = {
      estadoGestorCompletado: true
    };
    this.aportacionDisddrcaCtrSrv
      .nimaGestores(filtroNimaGestor)
      .subscribe((res: any) => (this.nimaGestorArray = res));
  }

  buscarNimaPoseedor() {
      const filtroNimaPoseedor: SolicitudNimaPoseedorDTO = {
        fechaAceptacion: this.searchForm.get('fechaAceptacion')?.value,
      };
  
      this.aportacionesDiPoseedorCtrSrv
        .nimaPoseedores(filtroNimaPoseedor)
        .subscribe((res) => {
          this.nimaPoseedorArray = res;
          this.poseedorArray = res;
        });
  }

  openModalContributions(element?: any) {
    if (!element) {
      if (this.rolesGestor?.length > 0) {
        if (this.nimaGestorArray?.length === 0) {
          this.snackBarSrv.showSnackBar(
            'No puede crear una Aportación DI/FS porque no tiene ningún Gestor en estado Completado.',
            'error'
          );
        }else{
          if (this.nimaGestorArray?.length > 1) {
            this.openHolderManagerSelection();
          } else {
            this.openModalContributions({
              acondicionador: this.nimaGestorArray[0],
              estado: { id: 1, descripcion: 'Abierta' },
            });
          }
        }
      } else if (this.rolesPoseedor?.length > 0) {
        if (this.nimaPoseedorArray?.length === 0) {
          this.snackBarSrv.showSnackBar(
            'No puede crear una Aportación DI/FS porque no tiene ningún Poseedor en estado Completado.',
            'error'
          );
        }else{
          if (this.nimaPoseedorArray?.length > 1) {
            this.openHolderManagerSelection();
          } else {
            this.openModalContributions({
              poseedor: this.nimaPoseedorArray[0],
              estado: { id: 1, descripcion: 'Abierta' },
            });
          }
        }
      }
    } else {
      const dialogRef = this.dialog.open(
        OpenSddrContributionsDisDialogComponent,
        {
          width: '950px',
          maxWidth: '98%',
          maxHeight: '95vh',
          data: element,
          disableClose: true,
        }
      );

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.searchData();
        }
      });
    }
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  canAccessAll(list: any) {
    const resultView = this.authService.can('sddr-ca-di', 'view');
    const resultDelete = this.authService.can('sddr-ca-di', 'delete');

    const resultSend = this.authService.can('sddr-ca-di', 'update-send');
    const resultAccept = this.authService.can('sddr-ca-di', 'update-accept');
    const resultCancel = this.authService.can('sddr-ca-di', 'update-cancel');

    const listPermission = list?.map((objeto: any) => {
      const estado1 = objeto.estado && objeto.estado.id === 1;
      const estado2 = objeto.estado && objeto.estado.id === 2;
      const estado3 = objeto.estado && objeto.estado.id === 3;
      const estado5 = objeto.estado && objeto.estado.id === 5;
      objeto.fechaMAceptacion =
        objeto.fechaAceptacion != null
          ? moment(new Date(objeto.fechaAceptacion)).format('DD/MM/YYYY')
          : null;
      objeto.fechaMAportacion =
          objeto.fechaAportacion != null
            ? moment(new Date(objeto.fechaAportacion)).format('DD/MM/YYYY')
            : null;
      let descripcionMCodLer = objeto.codigoLer ? 
        objeto.codigoLer?.tipoCodigo + ' ' + objeto.codigoLer?.descripcion
        : '';
      const hasDocument = objeto.documento ? true : false;

      return {
        ...objeto,
        canAccessView: resultView,
        canAccessDelete:
          resultDelete &&
          estado1 &&
          objeto.creadoPor == this.authService.getCurrentUserMail(),
        canAccessSend:
          resultSend &&
          estado1 &&
          objeto.creadoPor == this.authService.getCurrentUserMail(),
        canAccessAccept: resultAccept && (estado2 || estado5),
        canAccessCancel: resultCancel && (estado2 || estado3),
        canAccessPreview: hasDocument,
        descripcionMCodLer: descripcionMCodLer,
      };
    });

    return listPermission;
  }

  crearAutoFactura() {
    const list = this.gridArray.filter((x) => {
      return x.checked === true;
    });

    if (list.length == 0) {
      this.snackBarSrv.showSnackBar(
        `Debe seleccionar al menos una Aportación DI/FS para generar una prefactura`,
        'error'
      );
      return;
    }
    this.spinnerSrv.loadingShow();
    this.aportacionDisddrcaCtrSrv
      .generarAutoFactura(list)
      .subscribe({
        next: () => {
          this.snackBarSrv.showSnackBar(
            `La prefactura se ha creado correctamente`,
            'success'
          );
          this.searchData();
          this.spinnerSrv.loadingHide();
        },
        error: (err: any) => {
          console.log(err);
          this.spinnerSrv.loadingHide();
        },
      });
  }

  canAccessNuevoDis(): boolean {
    return this.authService.can('sddr-ca-di', 'create') || this.canViewResource("PO-GESTOR");
  }

  canAccessCrearAutoFactura(): boolean {
    return this.authService.can('sddr-ca-di', 'access-autofactura') || this.canViewResource("SDDR-CA-ENV-GEST");
  }

  onlyNumberKey(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control'];

    if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) return;

    // Permitir números y teclas adicionales definidas
    if (!/^[0-9;]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  esGestorEnvalora(){
    return this.canViewResource('SDDR-CA-ENV-GEST') || this.canViewResource('SDDR-CA-ENV-CONS') || this.canViewResource('PO-ENV-GEST') || this.canViewResource('PO-ENV-CONS');
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    const control = this.searchForm.get(filtro.campo);
    if (!control) {
      return;
    }

    if (filtro.value !== undefined) {
      const current = control.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v: any) => {
          if (v?.id !== undefined && filtro.value?.id !== undefined) {
            return v.id !== filtro.value.id;
          }
          return v !== filtro.value;
        });
        control.setValue(updated.length ? updated : null);
      }
    } else {
      control.reset();
    }

    //this.searchData(true);
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const gestor = this.searchForm.get('gestor')?.value as any[];
    if (gestor?.length) {
      gestor.forEach((g: any) => {
        const label = [g?.nima, g?.razonSocial].filter(Boolean).join(' - ') || String(g);
        filtros.push({ label, campo: 'gestor', value: g });
      });
    }

    const idGestor = this.searchForm.get('idGestor')?.value;
    if (idGestor) {
      filtros.push({ label: `${idGestor}`, campo: 'idGestor' });
    }

    const acondicionador = this.searchForm.get('acondicionador')?.value as any[];
    if (acondicionador?.length) {
      acondicionador.forEach((a: any) => {
        const label = [a?.nima, a?.razonSocial].filter(Boolean).join(' - ') || String(a);
        filtros.push({ label, campo: 'acondicionador', value: a });
      });
    }

    const idAcondicionador = this.searchForm.get('idAcondicionador')?.value;
    if (idAcondicionador) {
      filtros.push({ label: ` ${idAcondicionador}`, campo: 'idAcondicionador' });
    }

    const razonSocialGestor = this.searchForm.get('razon_social_gest')?.value;
    if (razonSocialGestor?.trim()) {
      filtros.push({ label: ` ${razonSocialGestor.trim()}`, campo: 'razon_social_gest' });
    }

    const documentoGestor = this.searchForm.get('codigo_documento_gest')?.value;
    if (documentoGestor?.trim()) {
      filtros.push({ label: ` ${documentoGestor.trim()}`, campo: 'codigo_documento_gest' });
    }

    const nimaGestor = this.searchForm.get('nima_gestor')?.value;
    if (nimaGestor?.trim()) {
      filtros.push({ label: ` ${nimaGestor.trim()}`, campo: 'nima_gestor' });
    }

    const razonSocialAcond = this.searchForm.get('razon_social_acond')?.value;
    if (razonSocialAcond?.trim()) {
      filtros.push({ label: ` ${razonSocialAcond.trim()}`, campo: 'razon_social_acond' });
    }

    const documentoAcond = this.searchForm.get('codigo_documento_acond')?.value;
    if (documentoAcond?.trim()) {
      filtros.push({ label: ` ${documentoAcond.trim()}`, campo: 'codigo_documento_acond' });
    }

    const nimaAcond = this.searchForm.get('nima_acondicionador')?.value;
    if (nimaAcond?.trim()) {
      filtros.push({ label: ` ${nimaAcond.trim()}`, campo: 'nima_acondicionador' });
    }

    const fechaAportDesde = this.searchForm.get('fecha_aport_desde')?.value;
    if (fechaAportDesde) {
      filtros.push({ label: ` ${moment(fechaAportDesde).format('DD/MM/YYYY')}`, campo: 'fecha_aport_desde' });
    }

    const fechaAportHasta = this.searchForm.get('fecha_aport_hasta')?.value;
    if (fechaAportHasta) {
      filtros.push({ label: ` ${moment(fechaAportHasta).format('DD/MM/YYYY')}`, campo: 'fecha_aport_hasta' });
    }

    const docIdentificacion = this.searchForm.get('doc_identificacion')?.value;
    if (docIdentificacion?.trim()) {
      filtros.push({ label: ` ${docIdentificacion.trim()}`, campo: 'doc_identificacion' });
    }

    const estado = this.searchForm.get('estado')?.value as any[];
    if (estado?.length) {
      estado.forEach((e: any) => {
        filtros.push({
          label: e?.descripcionCorta ?? e?.descripcion ?? String(e),
          campo: 'estado',
          value: e,
        });
      });
    }

    const plataformaOrigen = this.searchForm.get('plataformaOrigen')?.value;
    if (plataformaOrigen) {
      filtros.push({
        label: plataformaOrigen?.descripcion ?? String(plataformaOrigen),
        campo: 'plataformaOrigen',
      });
    }

    const origen = this.searchForm.get('origen')?.value;
    if (origen) {
      filtros.push({
        label: origen === 'SDDRCA' ? 'SDDR Abierto' : String(origen),
        campo: 'origen',
      });
    }

 const ordenes = this.searchForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }

    return filtros;
  }

  
    openModalMotivoCancel(item:any){
      const dialogRef = this.dialog.open(
        OpenSddrContributionsDisDeclineDialogComponent,
        {
          width: '750px',
          maxWidth: '95%',
          maxHeight: '95vh',
          data: {
            info: item,
          },
          disableClose: true,
        }
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.searchData();
        }
      });
    }

    vistaPreviaAportacion(element:any){
    const dialogRef = this.dialog.open(OpenSddrContributionsDisPreviewDialogComponent, {
      width: '98%',
      maxWidth: '98%',
      maxHeight: '95vh',
      data: element,
      disableClose: true,
    });
  }
  
}
